import React from 'react'
import {Helmet} from "react-helmet";

const NoPage = () => {
  return (
    <div>
      Not Found
    </div>
  )
}

export default NoPage
